var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChina(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 40.0001C31.0454 40.0001 39.9998 31.0458 39.9998 20.0001C39.9998 8.95436 31.0454 6.10352e-05 19.9998 6.10352e-05C8.95406 6.10352e-05 -0.000244141 8.95436 -0.000244141 20.0001C-0.000244141 31.0458 8.95406 40.0001 19.9998 40.0001Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9453 12.1719L12.6719 17.4844H18.2578L13.7422 20.7735L15.4687 26.086L10.9453 22.8047L6.42187 26.086L8.15625 20.7735L3.63281 17.4844H9.21875L10.9453 12.1719Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7109 30.9767L22.3906 29.3517L20.4375 30.1095L21.5703 28.3517L20.25 26.7188L22.2734 27.2579L23.4141 25.5001L23.5234 27.5938L25.5547 28.1329L23.5937 28.8829L23.7109 30.9767Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3359 26.211L26.9609 24.211L25.25 23.0001L27.3437 22.9688L27.9609 20.9688L28.6406 22.9532L30.7344 22.9297L29.0547 24.1797L29.7266 26.1641L28.0156 24.9532L26.3359 26.211Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.875 14.6797L28.9531 16.5626L30.4531 18.0235L28.3828 17.7266L27.4609 19.6016L27.1016 17.5391L25.0234 17.2422L26.8828 16.2657L26.5234 14.1954L28.0234 15.6563L29.875 14.6797Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7656 8.97662L23.6094 11.0626L25.5547 11.8516L23.5156 12.3516L23.3672 14.4454L22.2656 12.6641L20.2266 13.1641L21.5781 11.5626L20.4688 9.78912L22.4141 10.5782L23.7656 8.97662Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_293"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChina);
export default __webpack_public_path__ + "static/media/china.68dc49553b0e22e5d8c9b07c663c1ca9.svg";
export { ForwardRef as ReactComponent };